import {
  useUpdateAllEnvironmentVariablesForSiteMutation,
  UpdateAllEnvironmentVariablesForSiteMutationVariables,
} from "@modules/site/envVars/queries.generated"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"

export function useUpdateAllEnvironmentVariablesForSite() {
  const [setError, errorAlert] = useTriggerErrorAlert()

  const [mutate, result] = useUpdateAllEnvironmentVariablesForSiteMutation()

  const updateAllEnvironmentVariablesForSite = (
    {
      id: siteId,
      buildEnvironmentVariables,
      previewEnvironmentVariables,
    }: UpdateAllEnvironmentVariablesForSiteMutationVariables,
    onSuccess: () => void
  ) => {
    setError(null)
    return mutate({
      variables: {
        id: siteId,
        buildEnvironmentVariables,
        previewEnvironmentVariables,
      },
    })
      .then(({ data }) => {
        const isSuccessful =
          data?.updateBuildEnvironmentVariablesForSite?.success &&
          data?.updatePreviewEnvironmentVariablesForSite?.success
        if (isSuccessful && onSuccess) {
          onSuccess()
        }

        const errorMessage =
          data?.updateBuildEnvironmentVariablesForSite?.message ||
          data?.updatePreviewEnvironmentVariablesForSite?.message
        if (errorMessage) {
          return setError({
            message: errorMessage,
          })
        }
      })
      .catch(err => setError(err))
  }

  return [
    updateAllEnvironmentVariablesForSite,
    { ...result, errorAlert },
  ] as const
}
